<template>
<div class="campaign-container !py-0 !px-2">
    <div v-if="!isLanding">
      <img
      v-if="!$template.disabled_campaign_picture"
      :src="imgUrl($template.campaign_picture, 'campaign_personnalisation')"
      alt=""
      class="m-auto mb-4"
      />

      <div
      v-if="!$template.disabled_campaign_text && $template.campaign_template_mechanic_id !== 2 && $template.campaign_template_mechanic_id !== 3 && $template.campaign_template_mechanic_id !== 4 && $template.campaign_template_mechanic_id !== 5"
      class="mt-4 text-normal"
      v-html="tagText($template.campaign_text)"
      ></div>
    </div>
    <div v-else>
      <img
      v-if="!$template.landing_disabled_campaign_picture"
      :src="imgUrl($template.landing_campaign_picture, 'campaign_personnalisation')"
      alt=""
      class="m-auto mb-4"
      />

      <div
      v-if="!$template.disabled_campaign_text && $template.campaign_template_mechanic_id !== 2 && $template.campaign_template_mechanic_id !== 3 && $template.campaign_template_mechanic_id !== 4 && $template.campaign_template_mechanic_id !== 5"
      class="mt-4 text-normal p-4"
      v-html="tagText($template.landing_campaign_text)"
      ></div>
    </div>

    <p v-if="code1 && !$template.mandatory_purchase && $template.campaign_template_mechanic_id !== 2 && $template.campaign_template_mechanic_id !== 3 && $template.campaign_template_mechanic_id !== 4 && $template.campaign_template_mechanic_id !== 5 && !isLanding" class="m-auto w-fit sm:mt-4 font-bold text-[14px] lg:text-[24px]">Voici votre numéro de participation</p>
    <CodeTable v-if="code1 && !$template.mandatory_purchase && $template.campaign_template_mechanic_id !== 2 && $template.campaign_template_mechanic_id !== 3 && $template.campaign_template_mechanic_id !== 4 && $template.campaign_template_mechanic_id !== 5 && !isLanding" :code="code1.value.toString()" />
</div>
</template>

<script>
import CodeTable from './CodeTable.vue'
export default {
  components : {
    CodeTable
  },
  props : {
    isLanding: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    code1() {
      return this.$store.participationCode1 ?? null
    },
    code2() {
      return this.$store.participationCode2 ?? null
    }
  },
}
</script>

<style scoped>
.title {
  background-color: v-bind(
    "$template && !$template.disabled_campaign_title ? $template.campaign_title_background_color : ''"
  );
}

</style>
